<template>
  <div class="vote">
    <div style="height: 60px"></div>
    <div class="box-1 container flex">
      <el-image 
        style="width: 550px; height: 302px"
        :src="isHead(voteInfo.imgpath1)" 
        fit="cover">
        <el-image 
          style="width: 550px; height: 302px"
          :src="isHead()" 
          fit="cover">
        </el-image>
      </el-image>
      <div class="info-box flex-item">
        <div class="title">{{voteInfo.title}}</div>
        <div class="time">活动时间：{{formatTime(voteInfo.starttime, "YYYY-MM-DD HH:mm")}} 至 {{formatTime(voteInfo.endtime, "YYYY-MM-DD HH:mm")}}</div>
 
        <div class="count_down">
          <span v-if="countDown">{{countDown}}</span> 
        </div>
        <div class="setp flex">
          <div class="item" :class="[act_type >= 0 ? 'on' : '']">即将开始</div>
          <div class="item" :class="[act_type >= 1 ? 'on' : '']">进行中</div>
          <div class="item" :class="[act_type >= 2 ? 'on' : '']">已结束</div>
        </div>
        <div style="height: 40px"></div>
        <el-button type="primary" class="startBtn" color="#1A2E43" @click="openQuestion()" :loading="openLoading">参与问卷</el-button>
      </div>

    </div>

    <div style="height: 60px"></div>
    <div class="box-2" v-if="voteInfo.content">
      <div style="height: 60px"></div>
      <div class="container">
        <div class="content" v-html="Base64.decode(voteInfo.content)">

        </div>
      </div>
      <div style="height: 60px"></div>
    </div>
    
    <el-dialog
      v-model="dialogVisible"
      title="问卷内容"
      width="700px"
      :before-close="handleClose"
    >
      <el-form :model="formData" ref="formRef" label-width="100px" class="demo-dynamic">
        <div v-for="(v, index) in formData.domains" :key="v.key">
          <!-- 单选 -->
          <el-form-item
            v-if="v.ismulti*1 === 0"
            :label="v.title"
            :prop="'domains.' + index + '.value'"
            :rules="{
              required: true, message: '请先完成该问题', trigger: 'change'
            }"
          >
            <el-select v-model="v.value" placeholder="">
              <el-option v-for="item in v.items" :label="item.item" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 多选 -->
          <el-form-item
            v-else-if="v.ismulti*1 === 1"
            :label="v.title"
            :prop="'domains.' + index + '.value'"
            :rules="{
              required: true, message: '请先完成该问题', trigger: 'change'
            }"
          >
            <el-select v-model="v.value" multiple placeholder="">
              <el-option v-for="item in v.items" :label="item.item" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 问答 -->
          <el-form-item
            v-else-if="v.ismulti*1 === 2"
            :label="v.title"
            :prop="'domains.' + index + '.value'"
            :rules="{
              required: true, message: '请先完成该问题', trigger: 'blur'
            }"
          >
            <el-input v-model="v.value" />
          </el-form-item>
          <!-- 文件上传 -->
          <el-form-item
            class="file-item"
            v-else-if="v.ismulti*1 === 3"
            :label="v.title"
            :prop="'domains.' + index + '.value'"
            :rules="{
              required: true, message: '请先完成该问题', trigger: 'blur'
            }"
          >
            <el-input v-model="v.value" disabled></el-input>
            <el-button class="mt-2" @click.prevent="selectFile(index)" :loading="v.loading">选择文件</el-button>
          </el-form-item>
        </div>

      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="submitForm(formRef)" :loading="postLoading">提交问卷</el-button>
          <el-button @click="dialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 表单文件上传 -->
    <input type="file" ref="uploadRef" @change="changeFile" hidden>
  </div>
</template>

<script>
import { reactive, toRefs, ref, computed } from "vue"
import { api } from "@/api"
import { isHead, formatTime, count_down } from "@/tools"
import { ElMessage, ElNotification } from 'element-plus'
let Base64 = require('js-base64').Base64;
export default {
  name: "questionnaire",
  props: ['voteInfo', 'userid'],
  setup(props) {
    const formRef = ref()
    let uploadRef = ref(null)

    let initData = reactive({
      userid: computed(() => {
        return props.userid
      }),
      voteInfo: props.voteInfo,
      formData: {
        domains: []
      },

      countDown: "",    // 倒计时
      timer: "",        // 定时器
      act_type: -1,     // 0 未开始 1 进行中 2 已结束 --- 同时用于活动步骤
      serverTime: new Date().getTime(),

      dialogVisible: false, // 显示表单
      openLoading: false,

      file_i: 0, // 当前文件选择所在位置
      postLoading: false
    })
    // 获取服务器时间
    api("get", "getSystemTime")
      .then(res => {
        if(res.code === 1200) {
          initData.serverTime = res.data
          isState()
        } else {
          isState()
        }
      })
      .catch(err => {
        isState()
      })
    // 时间判断
    function isState() {
      let now_time = initData.serverTime
      let time;
      let { starttime, endtime } = initData.voteInfo
      if(starttime > now_time) {
        initData.act_type = 0
        time = starttime - now_time
        initData.timer = setInterval(() => {
          time -= 1000
          if(time < 1000) {
            initData.countDown = ""
            initData.act_type = 1
            clearInterval(timer)
          } else {
            initData.countDown = "距离投票开始还有：" + count_down(time)
          }
        },1000)
        return
      }
      if(starttime < now_time && endtime> now_time) {
        initData.act_type = 1
        time = endtime- now_time
        initData.timer = setInterval(() => {
          time -= 1000
          if(time < 1000) {
            initData.countDown = ""
            initData.act_type = 2
            clearInterval(timer)
          } else {
            initData.countDown = "距离投票结束还有：" + count_down(time)
          }
        },1000)
        return
      }
      if(endtime< now_time) {
        initData.countDown = ""
        initData.act_type = 2
        return
      }
    }
    // 获取问卷
    getQuestion()
    function getQuestion() {
      let data = { 
        userid: initData.userid,
        voteid: initData.voteInfo.voteid, 
        pageSize: 150 
      };
      api("get", "getVoteQuesList", data).then(res => {
        if(res.code === 1200) {
          res.data.forEach(item => {
            if(item.ismulti*1 === 1) { // 复选
              initData.formData.domains.push({
                value: [],
                key: item.questionid,
                title: item.question,
                ismulti: item.ismulti,
                items: item.items
              })
            } else {
              initData.formData.domains.push({
                value: item.ismulti*1 === 3 ? "/whg_server/userfiles/uploadfile/20220601141012/8594db66828a451eb11cd15c3056dfc1.png" : '',
                key: item.questionid,
                title: item.question,
                ismulti: item.ismulti,
                items: item.items,
                loading: false
              })
            }
          });
        } 
      })
  
    }
    // 打开问卷
    function openQuestion() {
      if(initData.userid === "anonymous") {
        ElMessage({
          message: '请登录后参与.',
          type: 'warning',
        })
        return
      } 
      initData.openLoading = true
      setTimeout(() => {
        initData.dialogVisible = true
      }, 100)
    }
    // 提交表单
    function submitForm(formEl) {
      
      if (!formEl) return
      initData.postLoading = true
      setTimeout(() => {
        formEl.validate((valid) => {
          if (valid) {
            let questionArr = []
            initData.formData.domains.forEach(item => {
              if(item.ismulti*1 === 0) {
                questionArr.push({
                  questionid: item.key,
                  item:[{itemid: item.value}],
                  sorce: 0,
                  answer: ""
                })
              } else if(item.ismulti*1 === 1) {
                let arr = []
                item.value.forEach(val => {
                  arr.push({itemid: val})
                })
                questionArr.push({
                  questionid: item.key,
                  item: arr,
                  sorce: 0,
                  answer: ""
                })
              } else if(item.ismulti*1 === 2 || item.ismulti*1 === 3) {
                questionArr.push({
                  questionid: item.key,
                  item:[],
                  sorce: 0,
                  answer: item.value
                })
              }
            })
      
            let formData = {
              articleid: initData.voteInfo.articleid,
              totalscore: 0,
              userid: initData.userid,
              question: questionArr,
              voteid: initData.voteInfo.voteid
            };

      
            api("post","postUserVote", formData)
              .then(res => {
                initData.postLoading = false
                if (res.code === 1200) {
                  initData.dialogVisible = false
                  ElNotification({
                    title: 'Success',
                    message: '问卷已提交',
                    type: 'success',
                  })
                } else {
                  ElNotification({
                    title: '提示',
                    message: res.msg,
                    type: 'error',
                  })
                }
              })
              .catch(err => {
                initData.postLoading = false
                ElNotification({
                  title: '提示',
                  message: '问卷提交失败！请重新尝试.',
                  type: 'error',
                })
              })
          
          } else {
            console.log(valid)
            console.log('error submit!')
            initData.postLoading = false
            return false
          }
        })
      }, 100)
      
    }
    // 触发文件上传
    function selectFile(index) {
      initData.file_i = index
      uploadRef.value.click()
      
    }
    // 文件上传
    function changeFile() {
      initData.formData.domains[initData.file_i].loading = true
      let _file = uploadRef.value.files
      if(Object.keys(_file).length == 0) {
        return
      }
      if(_file[0].size > 1024 * 1024 * 100) {
       
        ElMessage.warning('文件大小限制100M')
        return
      }
      const data = new FormData()
   
      data.append('file', _file[0])
      api("file", "uploadFile", data)
        .then(res => {
          if(res.code === 1200) {
            initData.formData.domains[initData.file_i].loading = false
            initData.formData.domains[initData.file_i].value = res.data[0]
            ElNotification({
              title: 'Success',
              message: '上传成功',
              type: 'success',
            })
          } else {
            ElNotification({
              title: '提示',
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(err => {
          initData.formData.domains[initData.file_i].loading = false
          ElNotification({
            title: '提示',
            message: '文件上传失败！请重新尝试.',
            type: 'error',
          })
        })

    }
    function handleClose(done) {
      initData.openLoading = false
      done()
    }
    return {
      ...toRefs(initData),
      isHead,
      formatTime,
      formRef,
      uploadRef,
      submitForm,
      Base64,
      openQuestion,
      selectFile,
      changeFile,
      handleClose
    }
  }
}
</script>

<style>
.header {
  border-bottom: 2px solid #F6F6F6;
  box-sizing: border-box;
}
</style>
<style lang="less" scoped>
.info-box {
  margin-left: 30px;
  .title {
    font-size: 24px;
    font-weight: bold;
  }
  .time {
    font-size: 14px;
    color: #8C96A1;
    margin-top: 20px;
  }
  .address {
    font-size: 14px;
    color: #8C96A1;
    margin-top: 15px;
  }
  .count_down {
    height: 85px;
    display: flex;
    align-items: flex-end;
    span {
      font-size: 18px;
      color: #10BB58;
    }
  }
  .setp {
    margin-top: 15px;
    .item.on {
      background-image: url('~@/assets/5101/img_2.png');
      color: #fff;
    }
    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 166px;
      height: 54px;
      background-image: url('~@/assets/5101/img_1.png');
      background-size: 100% 100%;
      color: #8C96A1;
      position: relative;
      left: -12px;
      padding-left: 10px;
      line-height: 1;
      box-sizing: border-box;
      &:first-child {
        left: 0;
      }
    }
  }
  .startBtn {
    height: 38px;
    padding: 11px 90px;
  }
}
.box-2 {
  background-color: #F6F6F6;
  .container {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .content {
      margin-right: 30px;
      :deep(img) {
        max-width: 100% !important;
        height: auto !important;
      }
    }
  }
  .tip {
    font-size: 20px;
    font-weight: bold;
  }
}
:deep(.el-form-item) {
  flex-flow: column;
  .el-form-item__label {
    width: 100% !important;
    text-align: left;
  }
}
:deep(.file-item) {
  .el-form-item__content {
    flex-wrap: unset;
    .el-button {
      margin-left: 20px;
    }
  }
}

:deep(.el-form-item__content) {
  margin: unset !important;
}
</style>